import { Button } from '@/shared/components';
import { applyAmountPrecision } from '@/shared/lib';
import { NUMERIC_CONFIG } from '@/shared/config';
import type { ExchangeAsset } from '../../model/types';

type Props = {
  assetToPay: ExchangeAsset;
  onSelect: (amount: string) => void;
};

const PERCENT_OPTIONS = [
  { label: '25%', multiplier: 0.25 },
  { label: '50%', multiplier: 0.5 },
  { label: 'MAX', multiplier: 1 },
];

const ExchangePercentChips = ({ assetToPay, onSelect }: Props) => {
  const handleClick = (multiplier: number) => {
    const amount = applyAmountPrecision(
      (assetToPay.available ?? 0) * multiplier,
      assetToPay.precision ?? NUMERIC_CONFIG.precision.default,
      'credit'
    );
    onSelect(String(amount));
  };

  return (
    <div className="flex items-center gap-[0.8rem]">
      {PERCENT_OPTIONS.map(({ label, multiplier }) => (
        <Button
          key={label}
          type="button"
          variant="outline"
          className="h-[2.4rem] rounded-[0.8rem] border border-stroke px-[0.8rem] py-0 shadow-none headline5 text-foreground hover:bg-secondary-bg hover:text-foreground"
          onClick={() => handleClick(multiplier)}>
          {label}
        </Button>
      ))}
    </div>
  );
};

export { ExchangePercentChips };
